var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Gallery',{attrs:{"images":[
    require('@/assets/img/sports/IMG_9475-1200w.jpg'),
    require('@/assets/img/sports/IMG_9478-1200w.jpg'),
    require('@/assets/img/sports/IMG_9483-1200w.jpg') ]}})}
var staticRenderFns = []

export { render, staticRenderFns }